import React from 'react';
import styled from 'styled-components';
import { ProductItemContainer } from '../StylesComponents';

type ProductListItemProps = {
  description: string;
  logo: string;
  name: string;
};

const Img = styled.img`
  max-width: 24px;
  max-height: 24px;
  border-radius: 6px;
`;

export const Description = styled.p`
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.2px;
  margin-top: 0;
  margin-bottom: 0;
`;

export const Container = styled.div`
  display: flex;
  align-items: stretch;
  margin-bottom: 24px;

  > div:first-child {
    &:empty {
      width: 24px;
      height: 24px;
    }
  }
`;

const ProductListItem = ({ description, logo, name }: ProductListItemProps) => {
  return (
    <Container>
      <div>{logo && <Img src={logo} alt={`Logo -${name}`} />}</div>
      <ProductItemContainer>
        <Description>{description}</Description>
      </ProductItemContainer>
    </Container>
  );
};

export default ProductListItem;
